import React from 'react'
import Eliteclub from "../../assets/Clubs/EliteImage.webp"
import Cultureclub from "../../assets/Clubs/Culture club.png"
import Tech_geeks from "../../assets/Clubs/Tech_geeks.png"
import ColabkeyClub from "../../assets/Clubs/ColabkeyClub.jpg"
import "./Clubs.css"

const Clubs = () => {
    return (
        <div className="main_Club_Top">
            <h2 className="Main_Clubs_Text">Clubs</h2>
            <hr className="custom-hr"/>
        <div style={{}} className='Main_club_details'>
            <img src={Eliteclub} className="EliteCLub"></img>
            <img src={Cultureclub} className="EliteCLub"></img>
            <img src={Tech_geeks} className="EliteCLub"></img>
            <img src={ColabkeyClub} className="EliteCLub"></img>
        </div>
        </div>
    )
}

export default Clubs
